import React from 'react';
import '../css/Header.css';

class Header extends React.Component {
  render() {
    return (
      <header className="Header">
        <h1>Sistema Solar</h1>
      </header>
    );
  }
}

export default Header;
